import superMeta from '../_ALG_CAT/metaAlgCatNode.mjs'

export default {
    ...superMeta,
    algNodeType: 'BDSUMMARY',
    algType: 'SUMMARY',
    name: '用户场景',
    type: 'BD_SUMMARY',
}
